import { useState } from "react";
import { useAuth } from "../hooks/auth/useAuth";
import { Link, useNavigate } from "react-router-dom";
import {
  BUTTON_STYLES,
  CARD_STYLES,
  TEXT_STYLES,
  INPUT_STYLES,
  BADGE_STYLES,
} from "../components/ui/CamberTheme";

export default function LoginPage() {
  const { login, error } = useAuth();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const handleLogin = (e) => {
    e.preventDefault();
    login(
      { username, password },
      {
        onSuccess: () => navigate("/dashboard", { replace: true }),
        onError: (err) => console.error("Login failed (page):", err),
      }
    );
  };

  return (
    <div
      className={`min-h-screen ${CARD_STYLES.page} flex items-center justify-center p-4`}
      style={{ fontFamily: "'Open Sans', sans-serif" }}
    >
      <form
        onSubmit={handleLogin}
        className={`w-full max-w-md ${CARD_STYLES.surfaceBordered} p-8`}
      >
        <div className="text-center mb-8">
          <img src="/camber.png" alt="Camber" className="h-10 w-auto mx-auto mb-4" />
          <h1 className={`${TEXT_STYLES.title} text-[20px]`}>Login</h1>
        </div>

        <div className="space-y-4">
          <div>
            <label className={`block mb-2 text-[12px] ${TEXT_STYLES.label}`}>Username</label>
            <input
              className={INPUT_STYLES.base}
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </div>

          <div>
            <label className={`block mb-2 text-[12px] ${TEXT_STYLES.label}`}>Password</label>
            <input
              className={INPUT_STYLES.base}
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <div className="mt-2 flex justify-end">
              <Link to="/forgot-password" className="text-[12px] leading-[155%] text-[#5937D6] hover:underline">
                Forgot password?
              </Link>
            </div>
          </div>
        </div>

        <button
          type="submit"
          disabled={login.isLoading}
          className={`w-full mt-6 py-2 ${BUTTON_STYLES.primary} disabled:opacity-50`}
        >
          {login.isLoading ? "Logging in..." : "Login"}
        </button>

        {error && (
          <div className="mt-4 p-3 rounded-[4px] bg-camber-dangerBg border border-camber-border">
            <p className={`text-sm ${BADGE_STYLES.danger}`}>{error}</p>
          </div>
        )}
      </form>
    </div>
  );
}
